// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u7nCBW9l8ZeiNm {
  display: flex;
  flex-direction: column;
  height: 100%;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding-bottom: 1px;
  padding-left: var(--ds-space-050, 4px);
  overflow: hidden;
  transition-property: background-color, border-color;
  transition-duration: 85ms;
  transition-timing-function: ease;
  border: 2px dashed var(--ds-border-accent-purple, #5e4db2);
  border-radius: var(--ds-border-radius-200, 6px);
  background-color: var(--ds-background-accent-purple-subtler, #dfd8fd);
  box-shadow: var(--ds-shadow-overflow, 0px 0px 8px rgba(9, 30, 66, 0.16), 0px 0px 1px rgba(9, 30, 66, 0.12));
  color: var(--ds-text-accent-purple, #5e4db2);
  font-size: 12px;
  line-height: 14px;
  cursor: pointer;
}
.xqGNNrcvzVmYz9 {
  display: flex;
  position: absolute;
  top: 50%;
  left: var(--ds-space-050, 4px);
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: var(--ds-space-0, 0);
  transform: translate(0, -50%);
  border-radius: var(--ds-border-radius-circle, 50%);
  background-color: var(--ds-background-accent-purple-subtler, #dfd8fd);
}
.sbp7Ns6hL7a9u0 {
  font-size: 12px;
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 16px;
}
.m9D9bklOa73THl {
  margin-bottom: var(--ds-space-100, 8px);
}
.fc-timegrid-event-harness.fc-timegrid-event-harness-inset:has( .inPlaceMessage) {
  /* stylelint-disable-next-line declaration-no-important */
  z-index: 1000 !important;
}
`, ""]);
// Exports
export var messageEvent = `u7nCBW9l8ZeiNm`;
export var popoverTitleIconContainer = `xqGNNrcvzVmYz9`;
export var popoverBodyText = `sbp7Ns6hL7a9u0`;
export var premiumLozenge = `m9D9bklOa73THl`;
export default ___CSS_LOADER_EXPORT___;
